import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"justify":"center","align":"center"}},[_c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"loader"}),_c('itw-icon',{attrs:{"width":60}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }